module.exports = __webpack_public_path__ + "img/kaist_gallery12.17eb8545.jpg";